import MD5 from "md5";
import ALI from "ali-oss";

export namespace OSS {
  const ossKey = "438zaYRJTbQ";
  const ossSecret = "brj6mf9peycyy";

  const GET = "GET";

  export const OSS_SERVER = "https://oss.trailerman.cn";
  export const ALI_OSS = "https://tcx.oss-cn-chengdu.aliyuncs.com";

  type Result<T> = {
    action: string;
    desc: string;
    error: string;
    result: T;
  };

  type Credentials = {
    access_key_id: string;
    access_key_secret: string;
    expiration: number;
    security_token: string;
  };

  async function request<T>(
    url: string,
    method: "GET" | "POST",
    headers?: Headers,
    body?: any
  ): Promise<{ data: T; headers: Headers }> {
    const req = new Request(url, {
      method,
      headers,
      body,
      mode: "cors",
    });

    const res = await fetch(req);

    if (res.status !== 200) {
      throw new Error(`StatusCode: ${res.status}`);
    }

    const hds = res.headers;
    const data: T = await res.json();

    return {
      data,
      headers: hds,
    };
  }

  export const getSignature = () => {
    const timestamp = Math.ceil(new Date().getTime() / 1000);
    const signature = MD5(`${ossKey}-${timestamp}-${ossSecret}`);

    return {
      timestamp,
      signature,
    };
  };

  export const getOssCredentials = async () => {
    const { timestamp, signature } = getSignature();
    const url = `${OSS_SERVER}/api/v1/sts/ak?access_key=${ossKey}&timestamp=${timestamp}&signature=${signature}`;
    const res = await request<Credentials>(url, GET);

    return res.data;
  };

  // 上传文件到阿里云OSS
  export const uploadToOSS = async (
    ak: Credentials,
    file: File,
    name: string
  ) => {
    const oss = new ALI({
      region: "oss-cn-chengdu",
      endpoint: "https://oss-cn-chengdu.aliyuncs.com",
      bucket: "tcx",
      accessKeyId: ak.access_key_id,
      accessKeySecret: ak.access_key_secret,
      stsToken: ak.security_token,
    });

    const res = await oss.multipartUpload(name, file, {
      progress: () => (done: () => void) => done(),
    });
    if (res.res.status !== 200) {
      throw new Error("上传文件失败");
    }

    return `https://tcx.oss-cn-chengdu.aliyuncs.com/${name}`;
  };

  // saveFile
  // 保存上传好的文件内容到服务器
  export const saveFile = async (
    url: string,
    feature: string,
    uploader: string,
    contentType: string
  ) => {
    const form = JSON.stringify({
      aid: "9xtfj78hgxs0",
      url,
      feature,
      uploader,
      content_type: contentType,
    });

    const { timestamp, signature } = getSignature();
    const path = `${OSS_SERVER}/api/v1/file/save?timestamp=${timestamp}&access_key=${ossKey}&signature=${signature}`;
    const headers = new Headers();
    headers.append("content-type", "application/json");
    const res = await request<Result<string>>(path, "POST", headers, form);
    if (res.data.error !== "") {
      throw new Error(res.data.error);
    }

    return res.data.result;
  };

  export const redirectToImage = (oid: string) => {
    return `${OSS_SERVER}/api/v1/file/oid/${oid}`;
  };

  export const dataURLtoFile = (dataurl: string, filename: string) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)!![1];
    const bstr = atob(arr[1]);
    let n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  export const url2file = async (url: string, filename: string) => {
    const res = await fetch(url);
    const contentType = res.headers.get("Content-Type");
    const blob = await res.blob();

    return new File([blob], filename, {
      type: contentType ? contentType : undefined,
    });
  };

  // 一口气上传和保存
  export const uploadAndSave = async (
    file: File,
    name: string,
    feature: string,
    uploader: string,
    contentType: string
  ) => {
    const ak = await getOssCredentials();
    const url = await uploadToOSS(ak, file, name);
    const oid = await saveFile(url, feature, uploader, contentType);
    return { url, oid };
  };
}
